import React, {useState, useEffect, useRef} from 'react';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import {useSelector} from "react-redux";
export default function SSEResponse(props) {
    const [response, setResponse] = useState('');
    const {size} = useSelector(state => state.fontSizeChange)
    const handleScrollContainer = ()=>{
        chatEndRef.current?.scrollIntoView({behavior: 'smooth'})
    }
    const answerThree = {
        fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
        paddingTop:'5px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    }
    const chatEndRef = useRef(null);
    const {sendTxt,setSendTxt,answer} = props
    var isLoad = true

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchEventSource('https://light-word.cn/api/hyperChat', {
                    method: 'POST',
                    headers: {
                        'accept': 'text/event-stream',
                        'Content-Type': 'application/json',
                        'auth-id': localStorage.getItem('ai-chat-auth-id'),
                    },
                    body: JSON.stringify(sendTxt),
                    onmessage(event) {
                        if(JSON.parse(event.data)['choices'][0]['delta']['content']!==undefined){
                            setResponse((prev) => prev + JSON.parse(event.data)['choices'][0]['delta']['content']);
                        }
                        setTimeout(()=>{handleScrollContainer()},100)
                    },
                    onclose() {
                        setSendTxt(null)
                        isLoad = true
                        console.log('Connection to SSE server closed');
                    },
                    onerror(err) {
                        setSendTxt(null)
                        isLoad = true
                        console.error('SSE error:', err);
                    },
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if(isLoad&&sendTxt){
            isLoad = false
            fetchData();
        }
        return () => {
        };
    }, []);
    useEffect(()=>{
        let dataArr = answer;
        dataArr['responder_content'][0]['type'] = 'text'
        dataArr['responder_content'][0]['text'] = response
        localStorage.setItem('ai-chat-tran-data',JSON.stringify(dataArr))
    },[response])
    return (
        <div>
            <div style={answerThree}>{response}</div>
            <div ref={chatEndRef}/>
        </div>
    );
}
